(() => {
	const initSlider = () => {
		const sections = Array.from(document.querySelectorAll('.js-slider-logos')) || [];

		if (sections.length === 0) return;

		sections.forEach((el) => {
			// Guard: avoid duplicate init on the same element
			if (el.dataset.sliderInitialized === 'true') return;
			const durationAttr = el.getAttribute('data-duration');
			const speed1 = (durationAttr ? Number(durationAttr) : 5) * 1000;

			// Destroy existing instance to avoid duplicates on section re-render
			if (el.swiper && !el.swiper.destroyed) {
				el.swiper.destroy(true, true);
			}

			new Swiper(el, {
				slidesPerView: 2,
				autoplay: {
					delay: 0,
					disableOnInteraction: false,
					pauseOnMouseEnter: false,
					waitForTransition: true,
				},
				allowTouchMove: false,
				loop: true,
				loopAdditionalSlides: 10,
				rewind: false,
				speed: speed1,
				breakpoints: {
					750: {
						slidesPerView: 3,
					},
					990: {
						slidesPerView: 4,
					},
					1200: {
						slidesPerView: 6,
					},
				},
			})

			// Mark as initialized
			el.dataset.sliderInitialized = 'true';
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		initSlider()
		// Handle Theme Editor dynamic loads safely; per-element guard prevents duplicates
		document.addEventListener('shopify:section:load', function (event) {
			initSlider()
		})
	}, { once: true })
})()
